export default __webpack_public_path__ + "static/AvenirLTStd-Medium-e66b769eef858825c7119e9dacb4d1c8.woff";